<h4 class="modal-title pull-left">Pres OK to Eject Ticket</h4>
